module.exports = __webpack_public_path__ + "static/media/truck-pickup.5416a5d5.svg";